<main
	*ngIf="vm$ | async as vm"
	class="container"
	[ngClass]="{ 'container--sidenav-opened': menuOpened.sidenavOpened && !isMobile }"
>
	<router-outlet />

	<!-- HEADER -->
	<div class="header">
		<button (click)="this.location.back()">
			<mat-icon svgIcon="porto-bank-icons:left-arrow"></mat-icon>
			Voltar
		</button>
		<h1>Detalhes {{ vm.order?.originalIntent === 'checkin' ? 'do Check-in' : 'da Reserva' }}</h1>
	</div>

	<!-- SWIPER -->
	<ui-porto-bank-swiper-container>
		<swiper-slide *ngFor="let url of vm.order?.venue?.banners">
			<figure class="image-container">
				<img [src]="url.value | optimizeImage" />
			</figure>
		</swiper-slide>
	</ui-porto-bank-swiper-container>

	<!-- Main Container -->
	<section class="venue-details" *ngIf="vm.order">
		<p class="venue-title">{{ vm.order.venue.name }}</p>

		<p class="venue-address">{{ vm.order.venue.address.value }}</p>

		<div class="order-details">
			<section class="body">
				<ul>
					<li>
						<p>Nome:</p>
						<span>{{ vm.client?.fullName }}</span>
					</li>
					<li>
						<p>Data:</p>
						<span>{{ vm.order.reservationDateTime | date: 'dd/MM/yyyy' }}</span>
					</li>
					<li>
						<p>Horário:</p>
						<span>{{ vm.order.reservationDateTime | date: 'HH:mm' }}</span>
					</li>
					<li>
						<p>Pessoas:</p>
						<span
							>{{ vm.order.partySize }}
							{{ vm.order.partySize === 1 ? 'pessoa' : 'pessoas' }}</span
						>
					</li>
				</ul>
			</section>

			<section class="reminder">
				<mat-icon svgIcon="porto-bank-icons:info" />
				<p>
					Lembre-se de pagar a conta do restaurante com seu cartão Porto Bank para ganhar os
					benefícios!
				</p>
			</section>
		</div>

		<div class="benefits-container">
			<h2>Benefícios</h2>
			<ul>
				<li *ngFor="let benefit of vm.order.benefits" class="benefit-item">
					<div class="benefit-item__value">
						<mat-icon svgIcon="porto-bank-icons:check"></mat-icon>
						{{ benefit.type === 'discount' ? benefit.value + ' de desconto' : benefit.name }}
					</div>

					<p>{{ benefit.descriptionLong }}</p>
				</li>
			</ul>
		</div>

		<div style="height: 120px; width: 100%"></div>
	</section>

	<div class="container-footer-buttons">
		<div class="footer-buttons">
			<button
				mat-button
				class="footer-button"
				*ngIf="!vm.order?.wasPaid && !vm.order?.isCanceled && !vm.order?.isValidated"
				(click)="cancelOrder(vm.order)"
			>
				<span>Cancelar {{ vm.order?.originalIntent === 'checkin' ? 'check-in' : 'reserva' }}</span>
			</button>
		</div>
	</div>
</main>
